import { getSearchValue, setSearchValue } from '../http';
class ConversationManager {
    constructor({ branchId, scribe, token }) {
        this.branchId = branchId;
        this.scribe = scribe;
        this.token = token;
        this.fiiSessionId = '';
        this.avaRoomRequest = '';
    }
    setTokenInURLIfExists() {
        if (this.token && getSearchValue(window, 'token') !== this.token) {
            setSearchValue(window, 'token', this.token);
            if (this.scribe && getSearchValue(window, 'scribe') !== this.scribe) {
                setSearchValue(window, 'scribe', this.scribe);
            }
        }
    }
    setAvaRequestIfExists() {
        this.avaRoomRequest = localStorage.getItem('ava_request');
    }
    shouldSignInAnonymously() {
        const conversationSessionExists = this.token || this.branchId || this.avaRoomRequest || this.fiiSessionId;
        return conversationSessionExists && localStorage.getItem('avaAccount') !== 'true';
    }
}
export default ConversationManager;
